"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelTransfer = exports.removeTransfer = exports.clearNonActiveTransfers = exports.getAllTransfers = exports.getTransferById = exports.deregisterActivityCallback = exports.registerActivityCallback = exports.initHttpGateway = exports.cleanupServerUrl = exports.testHttpGatewayConnection = void 0;
var index_1 = require("../index");
var helpers_1 = require("../helpers/helpers");
var messages_1 = require("../constants/messages");
var http_1 = require("../helpers/http");
/**
 * Check if HTTP Gateway server connection works. This function is called by init
 * when initializing the SDK.  This function can be used at any point for sanity checking.
 *
 * @returns promise that resolves if server can connect or rejects if server unable to connect
 */
var testHttpGatewayConnection = function () {
    if (!index_1.asperaHttpGateway.globals.serverUrl && !index_1.asperaHttpGateway.globals.supportMultipleServers) {
        (0, helpers_1.errorLog)(messages_1.messages.serverUrlNotSet);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.serverUrlNotSet));
        });
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var backupServerData = {
        endpoints: [
            '/aspera/http-gwy/v1/info',
            '/aspera/http-gwy/v1/upload',
            '/aspera/http-gwy/v2/upload',
            '/aspera/http-gwy/v1/download'
        ],
        name: 'IBM Aspera HTTP Gateway',
        version: '2.3.0',
        sdkVerificationFailed: true,
    };
    (0, http_1.apiGet)("".concat(index_1.asperaHttpGateway.globals.serverUrl || '', "/v1/info")).then(function (response) {
        response.json().then(function (data) {
            index_1.asperaHttpGateway.globals.serverInfo = data;
            index_1.asperaHttpGateway.globals.serverVerified = true;
            if (Number(index_1.asperaHttpGateway.globals.serverInfo.version.split('.')[0] || 0) >= 3) {
                promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.versionNotsupported, data));
                return;
            }
            console.warn(messages_1.messages.deprecationWarning);
            promiseInfo.resolver(data);
        });
    }).catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.serverError, error);
        if (index_1.asperaHttpGateway.globals.supportMultipleServers) {
            index_1.asperaHttpGateway.globals.serverInfo = backupServerData;
            index_1.asperaHttpGateway.globals.serverVerified = true;
            promiseInfo.resolver(backupServerData);
        }
        else {
            index_1.asperaHttpGateway.globals.serverVerified = false;
            promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.serverError, error));
        }
    });
    return promiseInfo.promise;
};
exports.testHttpGatewayConnection = testHttpGatewayConnection;
var cleanupServerUrl = function (serverUrl) {
    if (typeof serverUrl !== 'string') {
        return '';
    }
    if (serverUrl[serverUrl.length - 1] === '/') {
        serverUrl = serverUrl.slice(0, -1);
    }
    return serverUrl.replace('/v1', '/').replace(/\/$/, '').replace(/\/$/, '');
};
exports.cleanupServerUrl = cleanupServerUrl;
/**
 * Initialize HTTP gateway client. If client cannot (reject/catch)
 * client should attempt fixing server URL or trying again. If still fails disable UI elements.
 * If supportMultipleServers is used the failure of the first test will not lock out the SDK.
 *
 * @param serverUrl URL indicating location of the HTTP server
 * @param softwareMode indicate if the SDK should run in software mode instead of DOM mode
 * @param supportMultipleServers indicates if the SDK should support multiple servers (not restricting to setup server)
 *
 * @returns a promise that resolves if HTTP Gateway is running properly or rejects if unable to load
 */
var initHttpGateway = function (serverUrl, softwareMode, supportMultipleServers) {
    if (!(0, helpers_1.isValidUrl)(serverUrl)) {
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.invalidServerUrl));
        });
    }
    index_1.asperaHttpGateway.globals.setUpServer((0, exports.cleanupServerUrl)(serverUrl), softwareMode, supportMultipleServers);
    return (0, exports.testHttpGatewayConnection)();
};
exports.initHttpGateway = initHttpGateway;
/**
 * Register a callback event for getting transfer data
 *
 * @param callback callback function to receive transfers
 *
 * @returns ID representing the callback for deregistration purposes
 */
var registerActivityCallback = function (callback) {
    return index_1.asperaHttpGateway.activityTracking.setCallback(callback);
};
exports.registerActivityCallback = registerActivityCallback;
/**
 * Remove a callback from the transfer callback
 * @param id the ID returned by `registerActivityCallback`
 */
var deregisterActivityCallback = function (id) {
    index_1.asperaHttpGateway.activityTracking.removeCallback(id);
};
exports.deregisterActivityCallback = deregisterActivityCallback;
/**
 * Returns the transfer requested based on the uuid of the transfer.
 * NOTE: transferId from Node is not accepted as an ID.  It must be the ID used by the HTTP Gateway.
 *
 * @param id gateway based ID of the HTTP part of the transfer
 *
 * @returns an object containing the transfer (or undefined if not found) located at key `transfer_info`
 */
var getTransferById = function (id) {
    return { transfer_info: index_1.asperaHttpGateway.activityTracking.getTransferById(id) };
};
exports.getTransferById = getTransferById;
/**
 * Get transfer response object including all transfers
 *
 * @returns transfer data object with transfers array
 */
var getAllTransfers = function () {
    return index_1.asperaHttpGateway.activityTracking.getAllTransfersResponse();
};
exports.getAllTransfers = getAllTransfers;
/**
 * Remove all transfers that are not active
 */
var clearNonActiveTransfers = function () {
    index_1.asperaHttpGateway.activityTracking.clearNonActiveTransfers();
};
exports.clearNonActiveTransfers = clearNonActiveTransfers;
/**
 * Removes a transfer from the transfers list in HTTP Gateway
 * If an active transfer is removed it will continue to be uploaded/downloaded but progress will not be tracked
 *
 * @param id HTTP Gateway transfer uuid
 */
var removeTransfer = function (id) {
    index_1.asperaHttpGateway.activityTracking.removeTransfer(id);
};
exports.removeTransfer = removeTransfer;
/**
 * Cancel a transfer from the transfers list in HTTP Gateway
 *
 * @param id HTTP Gateway transfer uuid
 */
var cancelTransfer = function (id) {
    var transfer = index_1.asperaHttpGateway.activityTracking.getTransferById(id);
    if (transfer) {
        transfer.status = 'cancelled';
    }
};
exports.cancelTransfer = cancelTransfer;
exports.default = {
    initHttpGateway: exports.initHttpGateway,
    testHttpGatewayConnection: exports.testHttpGatewayConnection,
    registerActivityCallback: exports.registerActivityCallback,
    cleanupServerUrl: exports.cleanupServerUrl,
    deregisterActivityCallback: exports.deregisterActivityCallback,
    getTransferById: exports.getTransferById,
    getAllTransfers: exports.getAllTransfers,
    clearNonActiveTransfers: exports.clearNonActiveTransfers,
    removeTransfer: exports.removeTransfer,
    cancelTransfer: exports.cancelTransfer
};
